import React from 'react'
import Grid from '@material-ui/core/Grid'
import { StyledButton, StyledExternalLink, StyledParagraph } from '../../../theme/Global'
import { CustomH1, CustomH2, CustomH5, CustomLine, CustomLineWithMargin } from './styles'
import OffsiteContentComponent from '../../../common/components/offSiteContent'
import { downloadDashboardTips, downloadPostingsUserGuide } from '../../../static-files/static-pdf-service'
import AccountContact from '../../../common/components/AccountContact/AccountContact'

const ComplianceHelpRenderer = ({ match }) => (
  <Grid container>
    <Grid item xs={12}>
      <CustomH1>Help</CustomH1>
      <CustomLine />
    </Grid>
    <Grid item xs={12}>
      <CustomH2>GovDocs Learning Center</CustomH2>
      <StyledParagraph>
        The GovDocs Learning Center is a set of resources – including videos, user guides and other
        useful info – to help you best manage and monitor your labor law compliance program.
      </StyledParagraph>
      <Grid container>
        <Grid item xs={12} sm={4}>
          <iframe
            src="https://fast.wistia.net/embed/iframe/qekgqg41hq?videoFoam=true&playerColor=3d6c90"
            allowTransparency="true"
            frameBorder="0"
            scrolling="no"
            className="wistia_embed"
            name="wistia_embed"
            allowFullScreen
            mozallowfullscreen
            webkitallowfullscreen
            oallowfullscreen
            msallowfullscreen
            width="100%"
          />
          <StyledParagraph
            style={{ textAlign: 'center' }}
          >
            Download a Location List and Edit a Location Address
          </StyledParagraph>
        </Grid>
        <Grid item xs={12} sm={4}>
          <iframe
            src="https://fast.wistia.net/embed/iframe/tlkrf7yqcx?videoFoam=true&playerColor=3d6c90"
            allowTransparency="true"
            frameBorder="0"
            scrolling="no"
            className="wistia_embed"
            name="wistia_embed"
            allowFullScreen
            mozallowfullscreen
            webkitallowfullscreen
            oallowfullscreen
            msallowfullscreen
            width="100%"
          />
          <StyledParagraph
            style={{ textAlign: 'center' }}
          >
            Track Poster Shipments and Returns
          </StyledParagraph>
        </Grid>
        <Grid item xs={12} sm={4}>
          <iframe
            src="https://fast.wistia.net/embed/iframe/7h29922g55?videoFoam=true&playerColor=3d6c90"
            allowTransparency="true"
            frameBorder="0"
            scrolling="no"
            className="wistia_embed"
            name="wistia_embed"
            allowFullScreen
            mozallowfullscreen
            webkitallowfullscreen
            oallowfullscreen
            msallowfullscreen
            width="100%"
          />
          <StyledParagraph
            style={{ textAlign: 'center' }}
          >
            Reference Labor Law Posting Updates
          </StyledParagraph>
        </Grid>
      </Grid>
      <Grid />
      <CustomLine />
    </Grid>
    <Grid item xs={7}>
      <CustomH5>Dashboard Postings User Guide</CustomH5>
      <StyledParagraph>Download the user guide for more information.</StyledParagraph>
      <StyledButton onClick={downloadPostingsUserGuide}>Download Now</StyledButton>
    </Grid>
    <Grid item xs={5}>
      <AccountContact type="postings" />
    </Grid>
    <Grid item xs={12}>
      <CustomLineWithMargin />
    </Grid>
    <Grid item xs={12}>
      <CustomH2>FAQs</CustomH2>
      <OffsiteContentComponent contentKey="dashboard-faq" expanded={match.params.section == 'dashboard-faq'}/>
      <OffsiteContentComponent contentKey="compliance-faq" expanded={match.params.section == 'compliance-faq'}/>
      <OffsiteContentComponent contentKey="poster-check-faq" expanded={match.params.section == 'poster-check-faq'}/>
      <CustomLine />
    </Grid>
    <Grid item xs={12}>
      <CustomH2>Resources</CustomH2>
      <div>
        <StyledExternalLink onClick={downloadDashboardTips}>
          Tip Sheet: Getting Started with Dashboard
        </StyledExternalLink>
      </div>
    </Grid>
  </Grid>
)

export default ComplianceHelpRenderer
